import { Box, Button, Grid, Typography } from '@material-ui/core';
import { Chip } from 'common';
import {
  disableUserIntegration,
  getOAuthAndRedirectUser,
} from 'controllers/integrations';
import React, { PureComponent, Fragment } from 'react';
import EmailIdConflictModal from './emailIdConflictModal';

import './productDetails.scss';
import SimilarProductModal from './similarProductModal';

class ProductDetails extends PureComponent {
  constructor() {
    super();
    this.state = {
      similarProduct: '',
      conflictedEmailId: '',
    };
  }

  componentDidMount() {
    const { emailId = '' } = this.props.history.location;

    if (emailId) {
      this.setState({
        conflictedEmailId: emailId,
      });
    }
  }

  isSimilarProduct = () => {
    const { integrations, integrationId, integrationType } = this.props;

    const product = integrations.find(
      ({ integrationDto, isActive }) =>
        integrationType === integrationDto.integrationType &&
        integrationId !== integrationDto.integrationId &&
        isActive
    );

    if (product && Object.keys(product).length) {
      this.setState({
        similarProduct: product.integrationDto.product,
      });

      return product;
    }

    return false;
  };

  disableIntegration = (integrationId = '', isActive) => {
    const { userIntegrationId } = this.props;

    disableUserIntegration(integrationId || userIntegrationId, isActive);
  };

  onClickIntegrate = () => {
    const { product, userIntegrationId, isActive } = this.props;
    const productName = product.toLowerCase();

    this.setState({
      similarProduct: '',
    });

    if (isActive) {
      this.disableIntegration('', false);
      return false;
    }

    const isSimilarIntegration = this.isSimilarProduct();

    if (isSimilarIntegration) {
      return false;
    }

    if (userIntegrationId) {
      this.disableIntegration('', true);
      return false;
    }

    getOAuthAndRedirectUser(productName);
  };

  onActionModal = (action = 'close') => () => {
    const { history } = this.props;

    if (action === 'yes') {
      const similarProduct = this.isSimilarProduct();
      this.disableIntegration(similarProduct.userIntegrationId, false);
      this.setState({
        similarProduct: '',
      });

      return true;
    } else if (action === 'no') {
      history.push('/integrations');
      return true;
    }

    this.setState({
      similarProduct: '',
    });
  };

  onCloseConflictModal = () => {
    this.setState({
      conflictedEmailId: '',
    });
  };

  render() {
    const {
      product,
      shortDescription,
      logoURL,
      isActive,
      detailDescription,
      tags,
    } = this.props;
    const { similarProduct, conflictedEmailId } = this.state;

    return (
      <Fragment>
        <div className="product-details">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box display="flex">
                <img
                  src={logoURL}
                  alt={product}
                  className="product-details-image"
                />
                <Box className="product-details-text">
                  <Typography className="product-details-text-name">
                    {product}
                  </Typography>
                  <Typography className="product-details-text-description">
                    {shortDescription}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              container
              xs={6}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                aria-describedby="abs"
                variant="contained"
                color="primary"
                className={`integrate-button ${
                  isActive ? 'disable-button' : ''
                }`}
                onClick={this.onClickIntegrate}
              >
                {isActive ? 'Disable' : 'Integrate now'}
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} className="tags">
              {tags.map((tag) => (
                <Chip label={tag} />
              ))}
            </Grid>
          </Grid>
          <hr />
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Typography className="detailed-description">
                {detailDescription}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <SimilarProductModal
          productName={similarProduct}
          modalAction={this.onActionModal}
        />
        <EmailIdConflictModal
          emailId={conflictedEmailId}
          onClose={this.onCloseConflictModal}
        />
      </Fragment>
    );
  }
}

export default ProductDetails;

// notification -> Product (Gmail) Integration is disabled
